export default __webpack_public_path__ + "static/media/bg.ff69130a.png";